<template>
  <b-modal
    size="lg"
    centered
    id="modal-edit-page-harvest"
    hide-footer
    header-class="no-border"
    body-class="no-border"
    modal-class="modalStyle"
    no-close-on-backdrop
  >
    <div>
      <b-row
        v-for="(house, index) in houses"
        :key="index"
        class="align-items-center mb-4"
      >
        <b-col lg="2" md="3" sm="4">
          <b-row class="mb-1">
            <b-col class="label"> Nome </b-col>
          </b-row>
          <b-row>
            <b-col class="text-area mr-4">
              {{ house.name }}
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="3" md="5" sm="6">
          <b-row class="mb-1">
            <b-col class="label"> Cogumelo produzido </b-col>
          </b-row>
          <b-row>
            <b-col class="text-area mr-4">
              {{ house.mushrooms }}
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="3" md="5" sm="6">
          <b-row class="mb-1">
            <b-col class="label"> Classificação </b-col>
          </b-row>
          <b-row>
            <b-col class="text-area mr-1">
              {{ house.classification[0] }}
            </b-col>
            <b-col class="text-area mr-4">
              {{ house.classification[1] }}
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="2" md="3" sm="4">
          <b-row class="mb-1">
            <b-col class="label"> Composto </b-col>
          </b-row>
          <b-row>
            <b-col class="text-area mr-4">
              {{ house.compound }}
            </b-col>
          </b-row>
        </b-col>

        <button
          class="btn-edit mt-3"
          v-if="!rowSelected"
          @click="openEditMode(index + 1)"
        >
          <b-icon icon="pencil-fill"></b-icon>
        </button>

        <button
          class="btn-confirm mt-3"
          v-else-if="rowSelected == index + 1"
          @click="openModalConfirmExchange()"
        >
          <b-icon icon="trash2"></b-icon>
        </button>
      </b-row>

      <b-row class="justify-content-start mt-3 mb-1">
        <b-col cols="auto" style="padding-left: 0">
          <button class="btn-add">
            <b-icon icon="plus-circle" font-scale="1.5"></b-icon>
          </button>
        </b-col>
      </b-row>

      <b-row class="justify-content-end">
        <b-col cols="auto">
          <button class="btn-back" @click="backModal()">Voltar</button>
        </b-col>
      </b-row>
    </div>
    <ModalCompostExchange @responseModal="confirmExchange()" />
  </b-modal>
</template>

<script>
import ModalCompostExchange from './ModalCompostExchange.vue';

export default {
  components: { ModalCompostExchange },
  data() {
    return {
      houses: [
        {
          name: 'Casa 1',
          mushrooms: 'Shimeji',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
        {
          name: 'Casa 2',
          mushrooms: 'Shimeji',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
        {
          name: 'Casa 3',
          mushrooms: 'Shimeji',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
        {
          name: 'Casa 4',
          mushrooms: 'Shimeji',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
        {
          name: 'Casa 5',
          mushrooms: 'Shimeji',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
        {
          name: 'Shitake',
          mushrooms: 'Shitake',
          classification: ['Quilo', 'Bandeja'],
          compound: '',
        },
      ],
      rowSelected: null,
    };
  },
  methods: {
    backModal() {
      this.rowSelected = null;
      this.$bvModal.hide('modal-edit-page-harvest');
    },
    openEditMode(index) {
      this.rowSelected = index;
    },
    openModalConfirmExchange() {
      this.$bvModal.show('modal-compost-exchange');
    },
    confirmExchange() {
      this.rowSelected = null;
      this.$bvModal.hide('modal-compost-exchange');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}

::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #c1c1c1;
  padding: 10px 20px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

::v-deep button.close {
  color: #2c2c2c;
  outline: none;
}

.btn-edit,
.btn-confirm {
  color: white;
  text-align: center;
  border: none;
  border-radius: 40px;
  padding: 7px 12px 7px 12px;
  font-size: 15px;
}

.btn-edit {
  background-color: #615f5f;
}

.btn-confirm {
  background-color: #d65600;
}

.btn-edit:focus,
.btn-confirm:focus {
  outline: none;
}

.label {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #121212;
  padding-left: 0;
}

.text-area {
  border: 1px solid #000000;
  border-radius: 6px;
  min-height: 30px;
  padding: 0 0 0 5px;
  display: flex;
  align-items: center;

  font-weight: 400;
  font-size: 17px;
  line-height: 24px;

  color: #121212;
}

.btn-add {
  border: none;
  width: fit-content;
  height: fit-content;
  border-radius: 50%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-back {
  background-color: #313131;
  border-radius: 22px;
  width: 124px;
  height: 32px;
  border: none;

  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #ffffff;
}

.btn-back:focus,
.btn-add:focus {
  outline: none;
  border: none;
}
</style>
